<template>
  <div class="w-100">
    {{ contactType() }}

    <message-object :tooltip="messageContent()" type="Message" />

    sent to user,

    <user-object
      :entity-id="userId()"
      :name="userName()"
      :open-new="true"
      :tooltip="userProfile()"
    />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  methods: {
    contactType() {
      return this.$lodash.get(this.activity, "detail.channels[0]") === "sms" ? "Message" : "Email";
    },
  },
};
</script>
